export const imageExperienceContentStyle = () => ({
  '& .image-experience-content .add-image-content': {
    fontSize: 12,
    position: 'relative',
  },
  '& .image-experience-content .add-image-content .add-image-label': {
    marginBottom: 15,
    fontSize: 14,
    fontFamily: '"Segoe UI"',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  '& .image-experience-content .add-image-content .add-image-description': {
    marginBottom: 5,
  },
  '& .image-experience-content .add-image-content .search-box-container': {
    width: '45%',
    float: 'left',
  },
  '& .image-experience-content .add-image-content .search-box-container .search-box__input-group .search-box__input.form-control': {
    borderRadius: '0',
  },
  '& .image-experience-content .add-image-content .search-box-container .search-box__input-group .search-box__icon': {
    fontSize: 12,
  },
  '& .image-experience-content .add-image-content .add-image-button-bar': {
    marginTop: 15,
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container': {
    float: 'right',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector': {
    position: 'relative',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector button.dropdown-toggle': {
    borderRadius: '0',
    minWidth: 190,
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector button.dropdown-toggle .icon-right.glyphicon-triangle-bottom': {
    paddingTop: 3,
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-content': {
    border: 'none',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .empty-message': {
    position: 'absolute',
    padding: '5px 10px',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item': {
    padding: '5px 10px',
    margin: '0',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item:hover': {
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item.selected': {
    background: '#E7F0F6',
  },
  '& .image-experience-content .add-image-content .dropdown-selector-container .ba-dropdown-selector .ba-list-selector .list-selector-item .item-actions': {
    float: 'right',
  },
  '& .image-experience-content .add-image-content .sort-by-label': {
    paddingTop: 9,
    paddingRight: 5,
    float: 'right',
  },
  '& .image-experience-content .add-image-content .image-picker': {
    marginTop: 15,
    marginBottom: 5,
    backgroundColor: '#f4f4f4',
    padding: 15,
    border: '1px solid #bbb',
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images': {
    overflowY: 'auto',
    height: 400,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container': {
    position: 'relative',
    display: 'inline-block',
    padding: '0',
    margin: 10,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container:hover .image-dimensions, .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container:hover .image-edit.glyphicon.glyphicon-pencil, .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container:hover .image-delete.glyphicon.glyphicon-remove': {
    display: 'inline',
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .existing-image': {
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: '0',
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .existing-image img': {
    margin: 15,
    width: 225,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-dimensions': {
    display: 'none',
    position: 'absolute',
    bottom: 15,
    left: 15,
    textIndent: 5,
    color: 'white',
    backgroundColor: 'rgba(27,27,27,0.616)',
    width: 225,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-edit.glyphicon.glyphicon-pencil': {
    border: 'none',
    background: 'none',
    display: 'none',
    position: 'absolute',
    color: 'white',
    backgroundColor: 'rgba(27,27,27,0.616)',
    top: 15,
    right: 40,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-delete.glyphicon.glyphicon-remove': {
    border: 'none',
    background: 'none',
    display: 'none',
    position: 'absolute',
    color: 'white',
    backgroundColor: 'rgba(27,27,27,0.616)',
    top: 15,
    right: 15,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-name-container': {
    position: 'absolute',
    left: 15,
    bottom: '0',
    marginBottom: -15,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-name-container input': {
    width: 100,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-name-container button': {
    marginLeft: 3,
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-name-container [role=alert]': {
    position: 'absolute',
  },
  '& .image-experience-content .add-image-content .image-picker .existing-images .existing-image-container .image-name': {
    position: 'absolute',
    width: 225,
    left: 15,
    bottom: '0',
    marginBottom: -5,
    textAlign: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  '& .image-experience-content .add-image-content .file-picker-react-wrapper': {
    marginTop: 5,
    marginBottom: 5,
  },
  '& .image-experience-content .add-image-content .pagination-control-container': {
    marginBottom: 10,
  },
  '& .image-experience-content .add-image-content .pagination-control-container .ba-pagination>*': {
    display: 'inline',
  },
  '& .image-experience-content .add-image-content .pagination-control-container .pager-input': {
    border: '1px solid #BBB',
    width: 25,
    padding: '0 3px',
    marginRight: 5,
  },
  '& .image-experience-content .add-image-content .pagination-control-container .btn.btn-default': {
    border: 'none',
  },
  '& .image-experience-content .add-image-content .pagination-control-container .btn.btn-default:disabled': {
    backgroundColor: 'inherit',
  },
  '& .image-experience-content .add-image-content .pagination-control-container .btn.btn-default:disabled .glyphicon': {
    color: '#a2a2a2',
  },
  '& .image-experience-content .add-image-content .pagination-control-container span': {
    marginRight: 5,
  },
  '& .react-image-cropper': {
    textAlign: 'center',
  },
  '& .react-image-cropper .jcrop-handle': {
    backgroundColor: 'rgba(255,255,255,0)',
    opacity: '1',
    width: 20,
    height: 20,
  },
  '& .react-image-cropper .jcrop-handle.ord-ne': {
    borderRight: '6px #000000 solid',
    borderTop: '6px #000000 solid',
    top: '0',
    right: '0',
  },
  '& .react-image-cropper .jcrop-handle.ord-ne:before': {
    content: '" "',
    position: 'absolute',
    zIndex: '-1',
    width: 16,
    height: 16,
    opacity: '1',
    top: '0',
    right: '0',
    borderRight: '2px solid white',
    borderTop: '2px solid white',
    marginTop: -4,
    marginRight: -4,
  },
  '& .react-image-cropper .jcrop-handle.ord-se': {
    borderRight: '6px #000000 solid',
    borderBottom: '6px #000000 solid',
    bottom: '0',
    right: '0',
  },
  '& .react-image-cropper .jcrop-handle.ord-se:before': {
    content: '" "',
    position: 'absolute',
    zIndex: '-1',
    width: 16,
    height: 16,
    opacity: '1',
    bottom: '0',
    right: '0',
    borderRight: '2px solid white',
    borderBottom: '2px solid white',
    marginBottom: -4,
    marginRight: -4,
  },
  '& .react-image-cropper .jcrop-handle.ord-nw': {
    borderLeft: '6px #000000 solid',
    borderTop: '6px #000000 solid',
    top: '0',
    left: '0',
  },
  '& .react-image-cropper .jcrop-handle.ord-nw:before': {
    content: '" "',
    position: 'absolute',
    zIndex: '-1',
    width: 16,
    height: 16,
    opacity: '1',
    top: '0',
    left: '0',
    borderLeft: '2px solid white',
    borderTop: '2px solid white',
    marginTop: -4,
    marginLeft: -4,
  },
  '& .react-image-cropper .jcrop-handle.ord-sw': {
    borderLeft: '6px #000000 solid',
    borderBottom: '6px #000000 solid',
    bottom: '0',
    left: '0',
  },
  '& .react-image-cropper .jcrop-handle.ord-sw:before': {
    content: '" "',
    position: 'absolute',
    zIndex: '-1',
    width: 16,
    height: 16,
    opacity: '1',
    bottom: '0',
    left: '0',
    borderLeft: '2px solid white',
    borderBottom: '2px solid white',
    marginBottom: -4,
    marginLeft: -4,
  },
  '& .react-image-cropper .jcrop-holder': {
    display: 'inline-block',
  },
  '& .react-image-cropper .jcrop-holder .jcrop-tracker': {
    height: '100%',
    width: '100%',
  },
  '& .react-image-cropper .jcrop-holder .jcrop-keymgr': {
    visibility: 'hidden',
  },
  '& .image-experience-content .image-edit-content .edit-image-title': {
    fontSize: 14,
    fontFamily: '"Segoe UI"',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  '& .image-experience-content .image-edit-content .close-dialog-button': {
    top: 10,
    right: 5,
  },
  '& .image-experience-content .image-edit-content .image-preview-crop-description': {
    fontSize: 12,
    margin: '10px 0',
  },
  '& .image-experience-content .image-edit-content .image-cropper-in-edit': {
    padding: 5,
    marginTop: 30,
  },
  '& .image-experience-content .image-edit-content .image-cropper-in-edit .image-cropper-ratio-label': {
    fontSize: 12,
    margin: '5px 0',
    width: '100%',
    fontWeight: '700',
    textAlign: 'center',
  },
  '& .image-experience-content .image-edit-content .image-replace-description': {
    fontSize: 12,
    margin: '10px 0',
  },
  '& .image-experience-content .image-edit-content .preview-section': {
    border: '1px solid #CCCCCC',
  },
  '& .image-experience-content .image-edit-content .preview-section .preview-section-title': {
    marginLeft: 5,
    marginTop: 5,
    fontSize: 12,
    fontWeight: '700',
  },
  '& .image-experience-content .image-edit-content .image-edit-actions': {
    marginTop: 40,
  },
  '& .image-experience-content .modal-container.image-edit-modal .modal-content': {
    minWidth: 1350,
    width: 1350,
  },
  '& .image-experience-content .logo-item .logo-image-container': {
    position: 'relative',
    width: 62,
    fontSize: 13,
  },
  '& .image-experience-content .logo-item .logo-image-container .dropdown.btn-group': {
    position: 'absolute',
    width: '100%',
    bottom: '0',
  },
  '& .image-experience-content .logo-item .logo-image-container .dropdown.btn-group #logo-edit-dropdown': {
    color: 'white',
    background: 'rgba(0,0,0,0.3)',
    width: '100%',
    border: '0',
    padding: 2,
  },
  '& .image-experience-content .logo-item .logo-image-container .dropdown.btn-group .dropdown-menu': {
    margin: '0',
    borderRadius: '0',
    border: '2px solid rgba(0,0,0,0.15)',
  },
  '& .image-experience-content .logo-item .logo-image-container .dropdown.btn-group .dropdown-menu li a': {
    paddingLeft: 10,
  },
  '& .image-experience-content .add-image-button': {
    margin: '10px 0',
    background: '#008272',
  },
  '& .image-experience-content .on-add-logo-button': {
    margin: '10px 0',
  },
  '& .image-experience-content .logo-label': {
    marginTop: 10,
    fontSize: 12,
    fontWeight: '700',
    color: '#666666',
  },
  '& .image-experience-content .image-section-label': {
    paddingTop: 5,
  },
  '& .image-experience-content .close-dialog-button': {
    position: 'absolute',
    right: '0',
    top: '0',
    border: 'none',
    background: 'none',
    color: 'black',
    backgroundColor: 'unset',
  },
  '& .image-experience-content .button-as-link': {
    margin: '0',
    padding: '0',
    border: 'none',
  },
  '& .created-ad-list-container.row': {
    margin: '0',
  },
  '& .created-ad-list-container.row .ad-list-item': {
    boxSizing: 'content-box',
    height: 100,
    background: '#EEEEEE',
    padding: 10,
    display: 'table',
    border: 'dashed',
    borderWidth: 'thin',
    color: 'gray',
    width: 360,
    margin: '20px 20px 20px 20px',
    float: 'left',
    textAlign: 'center',
  },
  '& .created-ad-list-container.row .ad-list-item:first-child': {
    marginLeft: '0',
  },
  '& .created-ad-list-container.row .ad-list-item .create-another-ad': {
    lineHeight: '86px',
    color: '#00a2ff',
    fontSize: 14,
    border: 'none',
    backgroundColor: 'unset',
    padding: 2,
  },
  '& .created-ad-list-container.row .ad-list-item .create-another-ad:hover, .created-ad-list-container.row .ad-list-item .create-another-ad:active, .created-ad-list-container.row .ad-list-item .create-another-ad:focus': {
    border: 'none',
    outline: '0',
  },
  '& .created-ad-list-container.row .create-another-ad-container': {
    cursor: 'pointer',
  },
  '& .created-ad-list-container.row .existing-ad': {
    position: 'relative',
  },
  '& .created-ad-list-container.row .existing-ad p': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 12,
    lineHeight: '15px',
    textAlign: 'left',
  },
  '& .created-ad-list-container.row .existing-ad .existing-ad-image': {
    float: 'left',
    height: 100,
    marginRight: 10,
  },
  '& .created-ad-list-container.row .existing-ad .existing-ad-options': {
    display: 'none',
    position: 'absolute',
    width: '100%',
    height: 20,
    bottom: '0',
    left: '0',
    textIndent: 5,
    color: 'white',
    backgroundColor: 'rgba(27,27,27,0.616)',
    paddingRight: 5,
  },
  '& .created-ad-list-container.row .existing-ad .existing-ad-options button': {
    cursor: 'pointer',
    width: 'min-content',
    float: 'right',
    border: 'none',
    color: 'white',
    backgroundColor: 'unset',
    padding: '2px 5px',
    fontSize: 12,
  },
  '& .created-ad-list-container.row .existing-ad .existing-ad-options button:hover, .created-ad-list-container.row .existing-ad .existing-ad-options button:active, .created-ad-list-container.row .existing-ad .existing-ad-options button:focus': {
    border: 'none',
    outline: '0',
  },
  '& .created-ad-list-container.row .existing-ad:hover .existing-ad-options': {
    display: 'inline',
  },
  '& .react-image-experience .blocker': {
    backgroundColor: 'rgba(51,51,51,0.15)',
    zIndex: '1100',
    textAlign: 'center',
  },
  '& .react-image-experience .blocker .blocker-indicator': {
    marginTop: -55,
    top: '50%',
    position: 'relative',
    display: 'inline-block',
    padding: 20,
    backgroundColor: '#fff',
    maxWidth: 370,
    minWidth: 140,
    minHeight: 70,
    zIndex: '1011',
  },
  '& .react-image-experience .blocker-text': {
    verticalAlign: 'center',
    margin: '5px 0 0 40px',
    fontWeight: 'bold',
  },
  '& .react-image-experience .blocker-image': {
    background: 'url(\'../images/Loader_Grey_30x30.gif\') no-repeat',
    textAlign: 'left',
    position: 'absolute',
    height: 30,
    width: 30,
    zIndex: '10',
  },
});
